import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
const DesktopBodyScrollLock = ({
  children,
  className = '',
  enabled = true
}) => {
  const scrollRootRef = useRef();
  useEffect(() => {
    if (scrollRootRef.current) {
      if (enabled) {
        disableBodyScroll(scrollRootRef.current);
      } else {
        enableBodyScroll(scrollRootRef.current);
      }
    }
  }, [enabled]);
  useEffect(() => {
    const scrollElement = scrollRootRef.current;
    return () => {
      if (scrollElement) {
        enableBodyScroll(scrollElement);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div className={`${className} DesktopBodyScrollLock`} ref={scrollRootRef}>
      {children}
    </div>;
};
DesktopBodyScrollLock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  enabled: PropTypes.bool
};
export default DesktopBodyScrollLock;